import { render } from "./index.vue?vue&type=template&id=54af9f37"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=54af9f37&lang=css"

import exportComponent from "/home/smallred/20250930/inrunonline-website-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__